import { z } from "zod";
import { referenceRelationshipList } from "@/redux/features/candidateProfileSlice";

const schema = z.object({
  referenceName: z.string().min(1, "Your reference's name is required"),
  email: z.string().min(1, "Your reference's email is required"),
  relationship: z.enum(referenceRelationshipList),
  company: z.string().min(1, "The company you worked at is required"),
  title: z.string().min(1, "Your title at the time is required"),
  message: z.string().min(1, "A message to your reference is required"),
});

type Schema = z.infer<typeof schema>;

export {
  schema as candidateReferenceFormSchema,
  type Schema as CandidateReferenceFormSchema,
};
